/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/thumbs_up_medium'
export default icon
